export let julyAbbreviatedLowercase = "M$U2zb";
export default {julyAbbreviatedLowercase};